/**
 * 黄金 3 秒「画面」枚举(`hookPlan.visual`)→ 人话(2026-09-12 视频线四刀 ①)。
 *
 * ═══ 病灶 ═══════════════════════════════════════════════════════════════════
 * 幕二横幅此前把 `hookPlan.visual` 原样印出来,用户看到的是「画面:SCREEN_PROOF」——
 * 内部枚举直接漏到对客面。这批枚举是 ai 侧导演契约的视觉钩模板 key,用户从来不需要
 * 认识它们,他们只需要知道开场那一秒画面长什么样。
 *
 * ═══ 枚举出处 ═══════════════════════════════════════════════════════════════
 * gscq-ai `app/modules/video/domain/hooks.py::VISUAL_HOOKS`(8 个,权威全集);
 * 同文件 `_ALT_VISUAL` 与套路卡表只从这 8 个里取,不会有第 9 个。
 * 标签是那 8 条画面执行要点的**一句话压缩**,不是另起一套说法。
 *
 * ═══ 未知枚举宁可不显示 ═══════════════════════════════════════════════════════
 * 引擎若新增一个 key(表没跟上),硬印出来又会是一次枚举泄漏;硬猜又会贴错标签。
 * 所以:长得像枚举(全大写下划线)但不在表里 → 返 null,调用方整段不渲染。
 * 而导演偶尔会直接写一句中文画面描述(自然语言),那本来就是人话 → 原样显示。
 */
export const HOOK_VISUAL_LABELS: Record<string, string> = {
  OBJECT_REVEAL: "产品揭示登场",
  CHAOS_TO_ORDER: "混乱秒变整齐",
  SCREEN_PROOF: "屏幕/成果实拍",
  HUMAN_REACTION: "真人反应",
  TEXT_SLAM: "大字冲击",
  BEFORE_AFTER_SPLIT: "前后对比分屏",
  QUESTION_CLOSEUP: "特写发问",
  PHONE_INTERRUPT: "手机消息打断",
};

/** 长得像内部枚举:首字符大写字母,其余大写字母/数字/下划线(SCREEN_PROOF / TEXT_SLAM…)。 */
const ENUM_LIKE = /^[A-Z][A-Z0-9_]*$/;

/**
 * `hookPlan.visual` → 可直接上屏的文字。
 *
 * - 命中映射表 → 人话标签
 * - 长得像枚举但不在表里 → `null`(调用方**整段不渲染**,不许把裸枚举漏给用户)
 * - 其余(自然语言,含中文)→ 原样返回
 * - 空 / 非串 → `null`
 */
export function hookVisualLabel(visual?: string | null): string | null {
  if (typeof visual !== "string") return null;
  const v = visual.trim();
  if (!v) return null;
  const mapped = HOOK_VISUAL_LABELS[v];
  if (mapped) return mapped;
  if (ENUM_LIKE.test(v)) return null;
  return v;
}
